import { z } from 'zod';
/**
 * How a vehicle is powered.
 *
 * ⚠️ **A SEPARATE field, never part of the class name**, and the cohort is keyed
 * on the pair. A diesel and an electric 3.5-tonne van do the same job and are
 * not comparable: the EV has no litres at all, so a shared cohort takes a median
 * over a mixed population and reports it as the class norm. Folding it into the
 * class instead would double every entry — "Van — medium", "Van — medium
 * (electric)" — and that is the combinatorial list that rots.
 *
 * NULL is a normal state and means UNKNOWN, exactly as an unset class is. A
 * fleet that has not recorded drivetrains works unchanged; a vehicle with no
 * drivetrain simply compares against others that also have none, rather than
 * being assumed to burn diesel.
 *
 * Six values, not a taxonomy of powertrains. `HYBRID` and `PLUGIN_HYBRID` are
 * kept apart because a plug-in does a materially different share of its work on
 * the pack, which is exactly what the comparison would otherwise average over.
 */
export const DRIVETRAINS = [
    'DIESEL',
    'PETROL',
    'ELECTRIC',
    'HYBRID',
    'PLUGIN_HYBRID',
    'HYDROGEN',
];
export const drivetrainSchema = z.enum(DRIVETRAINS);
/** Display wording. Kept beside the values so a screen never invents its own. */
export const DRIVETRAIN_LABELS = {
    DIESEL: 'Diesel',
    PETROL: 'Petrol',
    ELECTRIC: 'Electric',
    HYBRID: 'Hybrid',
    PLUGIN_HYBRID: 'Plug-in hybrid',
    HYDROGEN: 'Hydrogen',
};
//# sourceMappingURL=vehicle-taxonomy.js.map